import { Action } from 'redux';
import { BasketActionTypes } from '../basket.types';
import { ACTION_CREATOR_NAME } from 'helpers';

export interface SetShowSessionHasExpiredWarningAction extends Action<BasketActionTypes.SET_SHOW_SESSION_HAS_EXPIRED_WARNING>{
    shouldShowSessionHasExpiredWarning: boolean;
}

export const setShowSessionHasExpiredWarning: (shouldShowSessionHasExpiredWarning: boolean) => SetShowSessionHasExpiredWarningAction = (shouldShowSessionHasExpiredWarning: boolean) => ({
    type: BasketActionTypes.SET_SHOW_SESSION_HAS_EXPIRED_WARNING,
    shouldShowSessionHasExpiredWarning
});
setShowSessionHasExpiredWarning[ACTION_CREATOR_NAME] = 'setShowSessionHasExpiredWarning';

export type SetShowSessionHasExpiredWarningFunc = (...args: Parameters<typeof setShowSessionHasExpiredWarning>) => void;